// extracted by mini-css-extract-plugin
export default {"accordion":"S6e5V","item":"fkhZh","wrapperTitle":"zkjQV","wrapperIcon":"hda3a","icon":"xgKKO","title":"Qcpbp","description":"JbGTK"};